import { useState } from 'react';
import { Button, Form } from 'react-bootstrap';
import { getNewInvitee, inviteUsers, ROLES } from './utils';
import AppSelector from './AppSelector';
import './userMgmt.scss';
import { Loading } from '@components';

/**
 * @desc Displays form to invite users by userName and assign
 * their role
 */

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export function InviteUsersModal({ appVal, appName, setAppVal, setAppName, onCancel }) {
  const [users, setUsers] = useState<any>([getNewInvitee()]);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [emailErrors, setEmailErrors] = useState<{ [key: number]: string }>({});

  const onChangeInviteeEmail = (e, index) => {
    const newUsers = JSON.parse(JSON.stringify(users));
    newUsers[index].userName = e.target.value;
    setUsers(newUsers);

    // Clear error when user starts typing
    if (emailErrors[index]) {
      const newErrors = { ...emailErrors };
      delete newErrors[index];
      setEmailErrors(newErrors);
    }
  };

  const validateEmail = (email, index) => {
    if (email && !EMAIL_REGEX.test(email)) {
      setEmailErrors((prev) => ({ ...prev, [index]: 'Invalid email format' }));
    } else {
      setEmailErrors((prev) => {
        const newErrors = { ...prev };
        delete newErrors[index];
        return newErrors;
      });
    }
  };

  const onChangePhoneNumber = (e, index) => {
    const newUsers = JSON.parse(JSON.stringify(users));
    newUsers[index].phoneNumber = e.target.value;
    setUsers(newUsers);
  };

  // Add new invitee row
  const onFocusEmail = (index) => {
    const newUsers = JSON.parse(JSON.stringify(users));
    newUsers.push(addInvitee());
    setUsers(newUsers);
  };

  // Delete invitee row
  const DeleteRow = (index) => {
    const newUsers = JSON.parse(JSON.stringify(users));
    newUsers.splice(index, 1);
    setUsers(newUsers);

    // Remove error for deleted row
    const newErrors = { ...emailErrors };
    delete newErrors[index];
    setEmailErrors(newErrors);
  };

  // Update user role
  const onChangeInviteeRole = (e, index) => {
    const newUsers = JSON.parse(JSON.stringify(users));
    newUsers[index].role = e.target.value;
    setUsers(newUsers);
  };

  // Get new row info
  const addInvitee = () => {
    return getNewInvitee();
  };

  // Process new invites
  const sendInvite = async () => {
    // Check if there are any validation errors
    if (Object.keys(emailErrors).length > 0) {
      return;
    }

    setIsLoading(true);

    const newUsers = users
      .filter((invitee) => !!invitee.userName)
      .map((invitee) => ({
        userName: invitee.userName,
        phoneNumber: invitee?.phoneNumber,
        role: invitee.role,
        applicationId: appVal,
      }));
    await inviteUsers({ users: newUsers, appName: appName });
    onCancel();
    setIsLoading(false);
  };

  if (isLoading) {
    return (
      <div className="d-flex flex-column align-items-center justify-content-center">
        <Loading />
        <span>&nbsp;Processing Users...</span>
      </div>
    );
  }

  return (
    <div>
      <AppSelector
        appVal={appVal}
        appName={appName}
        setAppVal={setAppVal}
        setAppName={setAppName}
      />

      <hr />

      {users.map((user, index) => {
        return (
          <div className="invite d-flex mb-4 justify-content-around" key={index}>
            {index === 0 ? (
              <Button
                variant="secondary"
                title="Add Email"
                className="mb-3 user-mgmt-add-email-btn"
                onClick={() => onFocusEmail(index)}
              >
                + Email
              </Button>
            ) : (
              <Button
                variant="danger"
                className="remove-user btn btn-outline-danger user-mgmt-remove-email-btn"
                title="Remove"
                onClick={() => DeleteRow(index)}
              >
                Remove
              </Button>
            )}
            <div className="col-sm-6 mr-1 mb-3 w-50 text-end position-relative email-wrap-form">
              <Form.Control
                type="email"
                as="input"
                placeholder="Email"
                value={user.userName}
                onChange={(e) => onChangeInviteeEmail(e, index)}
                onBlur={(e) => validateEmail(e.target.value, index)}
                isInvalid={!!emailErrors[index]}
              />
              <span className="invite-user-error">{emailErrors[index] || ''}</span>
            </div>
            <Form.Select
              className="role-select col-sm-3 mb-3 user-mgmt-form-input"
              value={user.role}
              onChange={(e) => onChangeInviteeRole(e, index)}
            >
              {ROLES.all.map((role) => {
                return (
                  <option key={role} value={role}>
                    {role}
                  </option>
                );
              })}
            </Form.Select>
          </div>
        );
      })}

      <div className="invite-btn d-flex justify-content-center mb-4">
        <Button
          variant="primary"
          title="Send Invite"
          onClick={sendInvite}
          disabled={!appVal || Object.keys(emailErrors).length > 0}
        >
          Send Invite
        </Button>
        <Button variant="secondary" title="Cancel" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    </div>
  );
}

export default InviteUsersModal;
